/* import __COLOCATED_TEMPLATE__ from './payload-preview.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();